/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/button-has-type */
import { Form, FormInstance, Radio } from 'antd';
import type { RadioChangeEvent } from 'antd';
import React, { FC, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Dropdown from '@/atoms/dropdown';
import { Location, Package, PACKAGE_TYPE } from '@core/booking/booking.types';

interface PackagesFormProps {
  availablePackages: Package[];
  selectedPackageId: number;
  setSelectedPackageId: (packageId: number) => void;
  selectedPackageType: PACKAGE_TYPE;
  setSelectedPackageType: (packageType: PACKAGE_TYPE) => void;
  locations: Location[];
  selectedLocationId: string;
  setSelectedLocationId: (locationId: string) => void;
  loadingPackages: boolean;
  form: FormInstance;
}

const PackagesForm: FC<PackagesFormProps> = ({
  locations,
  selectedLocationId,
  setSelectedLocationId,
  availablePackages,
  selectedPackageId,
  setSelectedPackageId,
  selectedPackageType,
  setSelectedPackageType,
  loadingPackages,
  form,
}) => {
  const { t } = useTranslation();
  const onChange = useCallback((e: RadioChangeEvent) => {
    setSelectedPackageId(e.target.value);
  }, []);

  useEffect(() => {
    form.resetFields(['package']);
  }, [selectedLocationId, selectedPackageType]);

  return (
    <div
      className="flex flex-wrap p-6 w-full justify-center top-0 md:top-8 relative"
      style={{ maxHeight: '600px', overflowY: 'auto' }}
    >
      <Form form={form} className="w-full flex flex-wrap p-6">
        <div className="w-full">
          <Form.Item
            initialValue={selectedLocationId}
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 25 }}
            style={{ textAlign: 'start' }}
            name="location"
            label={t('packages.location')}
            rules={[{ required: true, message: t('packages.validation.locationRequired') }]}
          >
            <Dropdown
              value={selectedLocationId}
              onChange={(e) => setSelectedLocationId(e)}
              options={locations.map((loc) => ({ label: loc.name, value: loc.id }))}
              name="Location"
            />
          </Form.Item>
        </div>
        <div className="w-full">
          <Form.Item
            initialValue={selectedPackageType}
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 25 }}
            style={{ textAlign: 'start' }}
            name="type"
            label={t('packages.type')}
            rules={[{ required: true, message: t('packages.validation.typeRequired') }]}
          >
            <Dropdown
              value={selectedPackageType}
              onChange={(e) => setSelectedPackageType(e)}
              options={[
                { label: t('packages.annual'), value: PACKAGE_TYPE.ANNUAL },
                { label: t('packages.monthly'), value: PACKAGE_TYPE.FLOATING },
              ]}
              name="Type"
            />
          </Form.Item>
        </div>

        <div className="w-full">
          <Form.Item
            initialValue={selectedPackageId}
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 25 }}
            style={{ textAlign: 'start' }}
            name="package"
            label={t('packages.package')}
            rules={[{ required: true, message: t('packages.validation.packageRequired') }]}
          >
            {loadingPackages && <span>{t('packages.loadingPackages')}</span>}
            {!loadingPackages && (availablePackages || [])?.length === 0 && (
              <span>{t('packages.noPackagesAvailable')}</span>
            )}
            {!loadingPackages && availablePackages && availablePackages.length > 0 && (
              <Radio.Group
                className="w-full md:max-h-60 overflow-visible md:overflow-y-auto"
                onChange={onChange}
                value={selectedPackageId}
              >
                {availablePackages.map((p) => (
                  <div key={p.id} className="pt-2 pb-3">
                    <Radio value={p.id}>
                      <span className="text-lg">
                        {t('packages.creditsPrice', { credits: p.credit_count, price: p.credit_price })}{' '}
                        <span dangerouslySetInnerHTML={{ __html: `<span>${p.currency_symbol}</span>` }} />
                      </span>
                    </Radio>
                  </div>
                ))}
              </Radio.Group>
            )}
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default PackagesForm;
